<template lang="pug">
  div
    page_header(title="Products", subhead="Overview")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "startup.products.create"}')
        i.feather-plus
        | Add New
    .row
      .col-sm-12
        .card(:class="sending?'loading':''")
          .card-body.border-bottom.py-3
            .d-flex
              per_page.text-muted(v-model="form.perPage" @input="form.page=1;load_data()")
              table_filter.ml-auto.text-muted(v-model="form.searchParam" :items="['name',  'stage', 'subsector', 'sector', 'model', 'status']" @input="load_data()")
              search.ml-3.text-muted(v-model="form.query" @search="form.page=1;load_data()")

          .table-responsive
            table.table.card-table.table-vcenter.text-nowrap.datatable
              thead
                tr
                  th Name
                  th Stage
                  th Sector
                  th Sub Sector
                  th Model
                  th Status
                  th
                  th

              tbody
                tr(v-for="item in products.data")
                  td {{item.name}}
                  td {{item.stage}}
                  td {{item.sector}}
                  td {{item.subsector}}
                  td {{item.model}}
                  td {{item.status}}
                  td.w-1
                    router-link(:to="item.id+'/edit'" v-if="user.user.permissions.includes('startups:product:edit')")
                      i.feather-edit
                  td.w-1
                    a(href="#" @click.prevent="delete_item(item.id)" v-if="user.user.permissions.includes('startups:product:delete')")
                      i.feather-trash

          pagination.card-footer.d-flex.align-items-center(:data="products", :page="form.page" @change="change_page")
  
</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import pagination from '@/components/pagination'
import perPage from '@/components/perPage'
import search from '@/components/search'
import filter from '@/components/filter'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Products',
  data(){
    return {
      products: [],
      form: {
        perPage : 10,
        searchParam: 'name',
        query: '',
        page:1
      }
    }
  },
  components: {
    page_header: page_header,
    pagination,
    per_page: perPage,
    search,
    table_filter: filter,
  },
  computed: {
    ...mapState('api', ['sending']),
    ...mapState('auth', ['user'])
  },
  methods:{
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'startups/products', method: 'GET', params: this.form })
        .then((response)=>{
          vm.products = response.data;
          vm.form.searchParam = response.searchParam;
          vm.form.query = response.query;
          vm.form.perPage = response.perPage;
          vm.form.page = response.data.current_page;
        });
    },
    delete_item(id){
      var vm = this;
      if(confirm('Are you sure?')){
        this.call({_vm: this, endpoint:'startups/products/'+id, method: 'DELETE'}).then(()=>{
          vm.load_data();
        })
      }
    },
    change_page(page){
      this.form.page = page;
      this.load_data();
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    this.load_data();
  }
}
</script>
